import React, { useRef } from "react";
import SelectableCard from "./SelectableCard";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { AnimatePresence, motion } from "framer-motion";


const containerVariants = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { staggerChildren: 0.1 } },
};
const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};


const BrandStepDesktopCarousel = ({ list, onBrandClick }) => {
    const trackRef = useRef(null);
    const scrollByCards = (dir = "right") => {
        if (!trackRef.current) return;
        const card = trackRef.current.querySelector(".selectable-card");
        const cardWidth = card?.offsetWidth || 220;
        trackRef.current.scrollBy({
            left: (dir === "right" ? 1 : -1) * cardWidth * 3,
            behavior: "smooth",
        });
    };


    return (
        <div className={`carousel-wrap ${list[0]?.image_url ? "as-parts" : "as-brands"}`}>
            <button className="carousel-nav left" onClick={() => scrollByCards("left")} aria-label="السابق">
                <FiChevronLeft size={44} />
            </button>


            <motion.div ref={trackRef} className="carousel-track" variants={containerVariants} initial="hidden" animate="show">
                {list.map((item) => (
                    <motion.div key={item.id} variants={cardVariants} whileHover={{ scale: 1.02 }} className="card-wrap">
                        <SelectableCard item={item} onClick={onBrandClick} />
                    </motion.div>
                ))}
            </motion.div>


            <button className="carousel-nav right" onClick={() => scrollByCards("right")} aria-label="التالي">
                <FiChevronRight size={44} />
            </button>
        </div>
    );
};


export default BrandStepDesktopCarousel;